import PropTypes from "prop-types"

import AdminZohoMailboxDeleteDialog from "./AdminZohoMailboxDeleteDialog"
import AdminZohoMailboxEditDialog from "./AdminZohoMailboxEditDialog"

export default function AdminZohoMailboxDialogHost({
  editRow,
  deleteRow,
  saving,
  dialogError,
  onClose,
  onSave,
  onConfirmDelete,
}) {
  return (
    <>
      <AdminZohoMailboxEditDialog
        open={Boolean(editRow)}
        mailbox={editRow}
        onClose={onClose}
        onSave={onSave}
        saving={saving}
        errorMessage={editRow ? dialogError : null}
      />
      <AdminZohoMailboxDeleteDialog
        open={Boolean(deleteRow)}
        mailbox={deleteRow}
        onClose={onClose}
        onConfirm={onConfirmDelete}
        saving={saving}
        errorMessage={deleteRow ? dialogError : null}
      />
    </>
  )
}

AdminZohoMailboxDialogHost.propTypes = {
  editRow: PropTypes.object,
  deleteRow: PropTypes.object,
  saving: PropTypes.bool,
  dialogError: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onConfirmDelete: PropTypes.func.isRequired,
}
